













































import { Component, Vue, Watch } from 'vue-property-decorator';
import ListItem from '../../components/core/ListItem.vue';
import CartFormContainer from '../../components/cart/CartFormContainer.vue';
import CartFormSelection from '../../components/cart/CartFormSelection.vue';
import CartFormInput from '../../components/cart/CartFormInput.vue';
import CartFormConfirmation from '../../components/cart/CartFormConfirmation.vue';
import { getStatusByWorkflow } from '@/services/graph/workflow.graph';
import { namespace } from 'vuex-class';
import { SlideService } from '../../services/modules/slide';
import { EventBus } from '../../event-bus';
import { Cart } from '@/interfaces/cart';
import { archiveSlides } from '@/services/graph/slide.graph';
import { GetterType } from '@/config/constants';
import { UpdateCycleService } from '@/services/modules/cycle';
import { getScopeFromRouter } from '@/router';
import UpdateCycle from '@/interfaces/models/UpdateCycle';
import localizationMixin from '../../mixins/localization-mixin';
import Slide from '../../interfaces/models/Slide';
const moment = require('moment');

const product = namespace('product');
const cart = namespace('cart');
const lib = namespace('library');

const slideService = new SlideService();

@Component({
  components: {
    listItem: ListItem,
    formContainer: CartFormContainer,
    cartFormSelection: CartFormSelection,
    cartFormInput: CartFormInput,
    cartFormConfirmation: CartFormConfirmation
  },
  mixins: [localizationMixin]
})
export default class CartActionView extends Vue {
  [x: string]: any;
  private window: number = 0;
  private data: any | null = null;
  private action: {} | null = null;
  private loading: boolean = false;
  @lib.State('map') slideMap!: { [key: string]: Slide };
  @cart.State(y => y.items) cartIds!: string[];
  @cart.Mutation('reset') resetCart!: () => void;

  @product.State(y => y.selected.workflow) workflow!: { _id: string } | null;

  private actionMap: {
    [key: string]: Cart.Action;
  } | null = null;

  mounted() {
    this.initRouter();
    this.actionMap = {
      '/change/status': {
        title: 'Change Status',
        documentKey: 'workflowStatus',
        action: (data: any) => {
          return slideService.patchMany(this.cartIds, { workflowStatus: data.id });
        },
        icon: 'mdi-checkbox-blank-circle-outline',
        component: 'cartFormSelection',
        data: () => {
          return this.workflow && this.workflow._id
            ? getStatusByWorkflow(this.workflow!._id).then((data: any) => {
                return data;
              })
            : null;
        },

        needConfirmation: true
      },
      '/change/updateCycle': {
        title: 'Save to Update Cycle',
        documentKey: 'updateCycle',
        selectable: true,
        selection: {
          text: 'name'
        },
        getSelectableItems: () => {
          const { product, country } = getScopeFromRouter() as { product: string; country: string };
          return new UpdateCycleService().list(product, country);
        },
        action: async (data: string | object) => {
          let cycle: UpdateCycle;
          if (typeof data === 'string') {
            const { product, country } = getScopeFromRouter() as { product: string; country: string };
            cycle = await new UpdateCycleService().newCycle({ country, productId: product, name: data });
          } else {
            cycle = data as UpdateCycle;
          }
          return slideService.patchMany(this.cartIds, { updateCycle: cycle });
        },
        icon: 'mdi-cached',
        component: 'cartFormInput',
        needConfirmation: false
      },
      ...(() => {
        if (!this.$store.getters['localization/isMaster']) return;
        return {
          '/localize': {
            title: 'Start Localization',
            documentKey: null,
            action: () => {
              return this.startLocalization({ slides: [...this.slides] });
            },
            icon: 'mdi-content-copy',
            component: null,
            needConfirmation: false
          }
        };
      })(),
      // '/change/updateCycle': {
      //   title: 'Save to Update Cylce',
      //   documentKey: 'updateCycle',
      //   action: () => {},
      //   icon: 'mdi-cached',
      //   component: 'cartFormInput',
      //   needConfirmation: false
      // },
      '/change/keyMessage': {
        title: 'New Key Message',
        documentKey: 'keyMessage',
        action: (data: string) => {
          return slideService.patchMany(this.cartIds, { keyMessage: data });
        },
        icon: 'mdi-key',
        component: 'cartFormInput',
        needConfirmation: false
      },
      '/change/zinc': {
        title: 'New Zinc',
        documentKey: 'zinc',
        action: async (data: string) => {
          await slideService.patchMany(this.cartIds, { zinc: data });
          const { IndesignService } = require('@/services/modules/indesign');
          return new IndesignService().updateZincBatch(this.cartIds);
        },
        icon: 'mdi-key',
        component: 'cartFormInput',
        needConfirmation: true
      },
      '/export/pdf': {
        title: 'Create PDF',
        documentKey: null,
        action: () => {
          const idsObject: { _id: string }[] = [];
          for (const id of this.cartIds) {
            idsObject.push({ _id: id });
          }
          const { ExportService } = require('@/services/modules/export');
          new ExportService()
            .asPdf('slide', GetterType.selection, `slides-${moment().format('YYYYMMDD')}.pdf`, idsObject)
            .then((link: HTMLElement) => {
              link.click();
            });
        },
        icon: 'mdi-pdf-box',
        component: null,
        needConfirmation: false
      },
      '/export/zip/indd': {
        title: 'Download Indesign Files',
        documentKey: null,
        action: () => {
          const { ExportService } = require('@/services/modules/export');
          new ExportService().downloadInddZip(this.cartIds).then((link: HTMLElement) => {
            link.click();
          });
        },
        icon: 'mdi-zip-box',
        component: null,
        needConfirmation: false
      },
      // '/start/localization': {
      //   title: 'Localize',
      //   action: () => {},
      //   icon: 'mdi-map-marker',
      //   documentKey: null,
      //   component: null,
      //   needConfirmation: false
      // },
      '/change/archive': {
        title: 'Archive',
        action: (data: string[]) => {
          return archiveSlides(this.cartIds);
        },
        icon: 'mdi-archive',
        documentKey: 'inArchive',
        component: null,
        needConfirmation: true
      },
      '/start/deletion': {
        title: 'Delete Assets',
        confirmationInfo:
          'Info: These slides will be deleted in 24 hours. You can restore them within this time frame.',
        action: async () => {
          const slideService = new SlideService();
          return await Promise.all(
            this.cartIds.map((id: string) => {
              return slideService.update(id, {
                deletion: {
                  willDelete: true,
                  willDeletedAfter: moment()
                    .add(1, 'day')
                    .toDate(),
                  deletedBy: {
                    email: this.$store.state.user.me.email,
                    name: this.$store.state.user.me.name
                  }
                }
              });
            })
          );
        },
        documentKey: '',
        icon: 'mdi-delete',
        component: null,
        needConfirmation: true
      }
    };
  }

  get slides() {
    return this.cartIds.map(i => this.slideMap[i]);
  }

  back() {
    this.window = 0;
    this.action = null;
    this.initRouter();
  }

  @Watch('$route.hash')
  onRouteChange(newHash: string) {
    if (!newHash) return;
    if (newHash === '#/nav') return (this.window = 0);
    if (!this.actionMap) return;
    const hash = newHash.split('#')[1];
    const action = this.actionMap[hash];

    if (action) {
      this.action = action;

      if (action.needConfirmation && action.component === null) {
        this.data = this.cartIds;
        this.window = 2;
      } else if (action.component) {
        this.window = 1;
      } else if (!action.needConfirmation && action.component === null) {
        // @ts-ignore
        this.processAction(this.action.action, false);
      } else {
        this.window = 0;
      }
    }
  }

  setData(data: {
    action: Cart.Action;
    data:
      | {
          id: string;
        }
      | string;
  }) {
    if (data) {
      this.data = data.data;
      if (data.action.needConfirmation) {
        this.window = 2;
      } else {
        this.processAction(data.action.action);
      }
    }
  }

  async processAction(action: Function, reload: boolean = true) {
    try {
      this.loading = true;
      await action(this.data);
      this.back();
      this.resetCart();
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
      if (reload) {
        EventBus.$emit('reload-lib', true);
      }
    }
  }

  initRouter() {
    this.$router.push({ hash: '/nav' });
  }
}
